import { render, staticRenderFns } from "./CoutDeProjet.vue?vue&type=template&id=354332f6&scoped=true&"
import script from "./CoutDeProjet.vue?vue&type=script&lang=js&"
export * from "./CoutDeProjet.vue?vue&type=script&lang=js&"
import style0 from "./CoutDeProjet.vue?vue&type=style&index=0&id=354332f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354332f6",
  null
  
)

export default component.exports